const i = (n) => n !== null;
function r(n, { repeat: o, repeatType: s = "loop" }, e) {
  const l = n.filter(i), t = o && s !== "loop" && o % 2 === 1 ? 0 : l.length - 1;
  return !t || e === void 0 ? l[t] : e;
}
export {
  r as getFinalKeyframe
};
